import HTMLRenderer from "./HTMLRenderer";

export default HTMLRenderer;
